import React from "react";
import get from "lodash/get";
import { StoryCard } from "../isomorphic/components/molecules/story-card";
import { CommentingWidget } from "../isomorphic/components/atoms/commenting-widget/commenting-widget";
import { StoryTags } from "../isomorphic/components/atoms/social-tags";
import { SubscriptionCTA } from "../isomorphic/components/molecules/subscription-cta";
import { RequestSubscription } from "../isomorphic/components/pages/subscription-page/request-subscription";
import StopPress from "../isomorphic/components/molecules/stop-press";

export function checkIfStoryPublic(story) {
  const access = get(story, ["access"], "subscribed");
  const isAGiftStory = story.isAGiftStory;

  return isAGiftStory || access === "public" || access === null;
}

function getStoryCards(cards = [], story, config, hasSubscription, firstSlideShowId) {
  return cards.map((card, index) => {
    const getSubscriptionCTA = get(card, ["metadata", "attributes", "subscriptioncta", 0], "No");
    const getNewsletter = get(card, ["metadata", "attributes", "newsletter", 0], null);
    const getNewsletterStoryCard = () => {
      return getNewsletter ? (
        <div className="newsletter-grid">
          <StoryCard key={index} card={card} story={story} config={config} firstVideoElementID={firstSlideShowId} />
          <div className="story-card">
            <StopPress planName={getNewsletter} />
          </div>
        </div>
      ) : (
        <StoryCard key={index} card={card} story={story} config={config} firstVideoElementID={firstSlideShowId} />
      );
    };
    if (getSubscriptionCTA === "Yes") {
      return (
        <React.Fragment>
          {getNewsletterStoryCard()}
          {!hasSubscription ? (
            <div className="story-card subscription-cta">
              <SubscriptionCTA url={story.slug} />
            </div>
          ) : null}
        </React.Fragment>
      );
    }
    return getNewsletterStoryCard();
  });
}

export function showStoryCards(storyCards, config, story, hasSubscription, firstSlideShowId) {
  return (
    <>
      {getStoryCards(storyCards, story, config, hasSubscription, firstSlideShowId)}
      <div className="story-tags">
        <StoryTags story={story} />
      </div>
      {!hasSubscription && checkIfStoryPublic(story) && (
        <div className="story-subscription">{<SubscriptionCTA url={story.slug} />}</div>
      )}

      <div className="metype-widget">
        <CommentingWidget story={story} />
      </div>
    </>
  );
}

function getIfNoAccess(storyCards, config, story, hasSubscription, firstSlideShowId) {
  const noOfVisibleCards = get(config, ["layout", "no-of-visible-cards-in-a-blocked-story"]);
  const eligibleCards = storyCards.slice(0, noOfVisibleCards);
  return (
    <>
      {getStoryCards(eligibleCards, story, config, hasSubscription, firstSlideShowId)}
      <RequestSubscription url={story.slug} />
    </>
  );
}

function getIfHasAccess(storyCards, config, story, hasSubscription, firstSlideShowId) {
  return showStoryCards(storyCards, config, story, hasSubscription, firstSlideShowId);
}

export function handleAccess(storyCards, config, story, hasSubscription, firstSlideShowId) {
  if (hasSubscription) {
    return getIfHasAccess(storyCards, config, story, hasSubscription, firstSlideShowId);
  }
  return getIfNoAccess(storyCards, config, story, hasSubscription, firstSlideShowId);
}
